import React, { useEffect } from 'react';

import './StatusComponent.css';
import { Bouwdeel, IdRegistration, Status } from 'src/common/types';

export type NetworkProps = {
  registration: IdRegistration;
  bouwdeel?: Bouwdeel;
  updateRegistration: (name: string, value: number) => void;
};

export const NetworkComponent = ({ registration, bouwdeel, updateRegistration }: NetworkProps) => {
  useEffect(() => {
    if (registration.parent_beyond) {
      updateRegistration('network_number', registration.parent_beyond.network_number);
    }
  }, [registration.parent_beyond]);

  useEffect(() => {
    if (bouwdeel?.network_number && !registration.parent_beyond) {
      updateRegistration('network_number', bouwdeel.network_number);
    }
  }, [registration.parent_beyond, bouwdeel]);

  return (
    <>
      {registration.status !== Status.MIGRATED ? (
        <div className="property">
          <label htmlFor="networknumber">Netwerknummer</label>
          <input
            type="number"
            id="networknumber"
            name="networknumber"
            value={registration.network_number || ''}
            disabled={!!registration.parent_beyond || !!bouwdeel?.network_number}
            className={registration.network_number === -1 ? 'error' : ''}
            onChange={e => updateRegistration('network_number', Number(e.target.value))}></input>
        </div>
      ) : null}
    </>
  );
};
